import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../auth/services/auth.service';

declare const window: any;

@Component({
    selector: 'app-floating-support',
    templateUrl: './floating-support.component.html',
    styleUrls: ['./floating-support.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
})
export class FloatingSupportComponent implements OnInit, OnDestroy {
    private authService = inject(AuthService);
    private dialog = inject(MatDialog);

    // Support widget script URL - consider moving to environment config
    private readonly SUPPORT_SCRIPT_URL = 'https://static.zdassets.com/ekr/snippet.js?key=41b299d1-aa41-4991-8f51-8d28a9591cc0';
    private scriptElement: HTMLScriptElement | null = null;

    ngOnInit(): void {
        this.loadSupportScript();
    }

    ngOnDestroy(): void {
        this.removeSupportScript();
    }

    /**
     * Check if current user is a player
     * @returns True if user is a player
     */
    isPlayer(): boolean {
        return this.authService.isPlayer;
    }

    /**
     * Open the support chat window
     */
    openSupportWindow(): void {
        if (window.zE) {
            window.zE('messenger', 'open');
        }
    }

    /**
     * Load the support widget script
     */
    private loadSupportScript(): void {
        // Check if script already exists
        if (document.getElementById('ze-snippet')) {
            return;
        }

        this.scriptElement = document.createElement('script');
        this.scriptElement.src = this.SUPPORT_SCRIPT_URL;
        this.scriptElement.type = 'text/javascript';
        this.scriptElement.async = true;
        this.scriptElement.id = 'ze-snippet';

        document.head.appendChild(this.scriptElement);
    }

    /**
     * Remove the support widget script on component destruction
     */
    private removeSupportScript(): void {
        // Only attempt removal if we have a reference and the element exists
        if (this.scriptElement && document.getElementById('ze-snippet')) {
            document.head.removeChild(this.scriptElement);
            this.scriptElement = null;
        }
    }
}
